// src/contexts/ROContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";

const API_BASE_URL = "https://api.drivergems.com";
const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";

function generateSignature(method, urlPath, timestamp) {
  const message = `${method}${urlPath}${timestamp}`;
  return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
}

const ROContext = createContext();

export const ROProvider = ({ children }) => {
  const [roList, setRoList] = useState([]);
  const [selectedRoId, setSelectedRoId] = useState(() => {
    try {
      return localStorage.getItem("selectedRoId") || null;
    } catch (e) {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRoList = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const timestamp = Math.floor(Date.now() / 1000).toString();
        const userUrlPath = "/v1/user/ros";
        const userSignature = generateSignature("GET", userUrlPath, timestamp);

        const response = await axios.get(`${API_BASE_URL}${userUrlPath}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Signature": userSignature,
            "X-Timestamp": timestamp,
          },
        });

        const list = response.data?.ro_list || [];
        setRoList(list);

        // if no selectedRoId saved or saved value not in list, set default
        const savedRoId = localStorage.getItem("selectedRoId");
        const found = list.find((r) => String(r.id) === String(savedRoId));
        if (savedRoId && found) {
          setSelectedRoId(savedRoId);
        } else if (list.length > 0) {
          const defaultId = list[0].id;
          setSelectedRoId(String(defaultId));
          localStorage.setItem("selectedRoId", String(defaultId));
        }
      } catch (err) {
        console.error("ROContext: failed to load RO list", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRoList();
  }, []);

  // persist selection
  useEffect(() => {
    try {
      if (selectedRoId) localStorage.setItem("selectedRoId", String(selectedRoId));
      else localStorage.removeItem("selectedRoId");
    } catch (e) {}
  }, [selectedRoId]);

  return (
    <ROContext.Provider value={{ roList, selectedRoId, setSelectedRoId, loading }}>
      {children}
    </ROContext.Provider>
  );
};

export const useRO = () => {
  const ctx = useContext(ROContext);
  if (!ctx) throw new Error("useRO must be used within ROProvider");
  return ctx;
};
